export default {
  name: 'DynamicElement',
  props: {
    tag: { type: String, default: 'div' }
  },
  render: (h, { props, slots }) => h(props.tag, slots.default ? slots.default() : undefined)
}
